import React, { Component } from 'react';
import config from '../../config';
import logo from '../../public/logo.png';


const GlobalFooter = () => (
  <footer className="footer">
    <div className="footer-container">
      <div className="company-details">
        <img className="brand footer-logo" src={logo} alt="Buoyweather" />
        <h2>The Global Marine Forecasting Solution</h2>
        <p>&#169; {new Date().getFullYear()} Surfline\Wavetrak, Inc.</p>
        <p><a href={config.links.terms} target="_blank">Terms & Conditions</a> and <a href={config.links.privacy} target="_blank">Privacy Policy</a></p>
        <p>Partner of USATODAY Lifestyle/Action Sports</p>
      </div>
      <ul className="footer__menu" >
        <li>
          <h2 className="heading">Company</h2>
          <ul>
            <li><a href={config.links.careers}>Careers</a></li>
          </ul>
        </li>
        <li>
          <h2 className="heading">Support</h2>
          <ul>
            <li><a href={config.links.support}>Support Center</a></li>
            <li><a href={config.links.account.information}>My Account</a></li>
            <li><a href={config.links.funnel.gift_cards}>Gift Cards</a></li>
            <li><a href={config.links.sitemap}>Site Map</a></li>
          </ul>
        </li>
        <li>
          <h2 className="heading">Network</h2>
          <ul>
            <li><a href={config.links.surfline}>Surfline</a></li>
            <li><a href={config.links.magicseaweed}>Magicseaweed</a></li>
            <li><a href={config.links.fishtrack}>Fishtrack</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </footer>
  );

export default GlobalFooter;



// WEBPACK FOOTER //
// ./src/components/GlobalFooter/GlobalFooter.js